import React from 'react'

import Label from '@/components/Label'
import cn from '@/utilities/cn'

export interface FormComponent<T = any> {
  value?: T
  disabled?: boolean
  onChange?: (value: T) => void
  formatProps: GenericInput
}

interface GenericInput {
  name: string
  label?: string
  details?: React.ReactNode
  helpText?: string
  required?: boolean
  error?: string | { message?: string; [key: string]: unknown }
  icon?: React.ReactNode
  children?: React.ReactNode
  className?: string
  includeFormatting?: boolean
  disabled?: boolean
}
const GenericInput = ({
  name,
  label,
  details,
  helpText,
  required,
  error,
  icon,
  className,
  children,
  includeFormatting = true,
  disabled = false
}: GenericInput) => {
  return includeFormatting ? (
    <div className={cn('mt-5', className)}>
      <div className="flex">
        {icon && <div className="mx-1 h-6 w-6 text-brand-400">{icon}</div>}
        {label && (
          <Label
            className={
              disabled
                ? 'block text-sm font-semibold leading-6 text-zinc-600'
                : 'block text-sm font-semibold leading-6 text-zinc-900'
            }
            htmlFor={name}
            required={required}
          >
            {label}
          </Label>
        )}
      </div>
      {details &&
        (typeof details === 'string' ? (
          <p className="mt-3 mb-4 text-sm font-normal leading-6 text-zinc-500">{details}</p>
        ) : (
          <div>{details}</div>
        ))}
      {children}
      {helpText && <p className="mt-1 text-xs text-zinc-500">{helpText}</p>}
      {error && <p className="mt-1 text-sm text-red-500">{typeof error === 'string' ? error : error?.message}</p>}
    </div>
  ) : (
    children
  )
}

export default GenericInput
